import PageContainer from '../components/PageContainer';
import Diary from '../components/Diary';

const DiaryPage = () => {
  return (
    <PageContainer>
      <Diary />
    </PageContainer>
  );
};

export default DiaryPage; 